import { gql, useQuery } from '@apollo/client';

export const GET_PENDING_TENANT_REGISTRATION_COUNT = gql`
  query GetPendingTenantRegistrationCount {
    pendingTenantRegistrationCount
  }
`;

export interface PendingTenantRegistrationCountData {
  pendingTenantRegistrationCount: number;
}

interface Options {
  skip?: boolean;
}

export function usePendingTenantRegistrationCountQuery({ skip }: Options = {}) {
  return useQuery<PendingTenantRegistrationCountData>(GET_PENDING_TENANT_REGISTRATION_COUNT, {
    skip,
    fetchPolicy: 'cache-and-network',
  });
}
